import React from 'react';

const DetailsTitle = ({ title, image }) => (
    <div className="ckp-admin-forms-header ckp-admin-grid-row">
        {image ? (
            <React.Fragment>
                <div
                    className="ckp-admin-forms-show-image-background  u-index-back"
                    style={{ backgroundImage: `url(${image})` }}
                />
                <div className="ckp-admin-grid-column">
                    <img className="ckp-admin-forms-show-image u-index-top" alt="Contact" src={image} />
                </div>
            </React.Fragment>
        ) : null}
        <div className="ckp-admin-grid-column u-vertical-center">
            <h1 className="ckp-ts-h1 u-index-top">{title}</h1>
        </div>
    </div>
);

export default DetailsTitle;



// WEBPACK FOOTER //
// ./src/components/admin/forms/DetailsTitle.js